"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ANALYTICS_SCHEMA_VERSION_EVENT_STREAM", {
  enumerable: true,
  get: function get() {
    return _analyticsParser.ANALYTICS_SCHEMA_VERSION_EVENT_STREAM;
  }
});
Object.defineProperty(exports, "ANALYTICS_SCHEMA_VERSION_V2", {
  enumerable: true,
  get: function get() {
    return _analyticsParser.ANALYTICS_SCHEMA_VERSION_V2;
  }
});
Object.defineProperty(exports, "ANALYTICS_SCHEMA_VERSION_V2_CALLBACK", {
  enumerable: true,
  get: function get() {
    return _analyticsParser.ANALYTICS_SCHEMA_VERSION_V2_CALLBACK;
  }
});
Object.defineProperty(exports, "ANALYTICS_SCHEMA_VERSION_V3", {
  enumerable: true,
  get: function get() {
    return _analyticsParser.ANALYTICS_SCHEMA_VERSION_V3;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "getVoicebaseAnalytics", {
  enumerable: true,
  get: function get() {
    return _getVoicebaseAnalytics["default"];
  }
});
Object.defineProperty(exports, "getVoicebaseMediaUrl", {
  enumerable: true,
  get: function get() {
    return _getVoicebaseMediaUrl["default"];
  }
});
exports.reactPlayerVersion = void 0;

var _getVoicebaseMediaUrl = _interopRequireDefault(require("./utilities/getVoicebaseMediaUrl"));

var _getVoicebaseAnalytics = _interopRequireDefault(require("./utilities/getVoicebaseAnalytics"));

require("@fontsource/montserrat");

var _package = _interopRequireDefault(require("../package.json"));

var _VoicebaseReactPlayer = _interopRequireDefault(require("./VoicebaseReactPlayer"));

var _analyticsParser = require("./utilities/analytics-parser");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Decorators and standardised implementations of the player
 */
// import IntegratedUrlPlayer from './decorators/IntegratedUrlPlayer';

/**
 * Core player for custom implementations where a decorator isn't required
 */
_VoicebaseReactPlayer["default"].getVoicebaseMediaUrl = _getVoicebaseMediaUrl["default"];
_VoicebaseReactPlayer["default"].getVoicebaseAnalytics = _getVoicebaseAnalytics["default"];
var reactPlayerVersion = _package["default"].version;
/**
 * We export AVAILABLE schema versions as they are used as input variables.
 */

exports.reactPlayerVersion = reactPlayerVersion;
var _default = _VoicebaseReactPlayer["default"];
exports["default"] = _default;